module.exports = __webpack_public_path__ + "media/assets/images/tour/3_Tour_5-07df55e5f80a4ee286e3052fc1eea276.png";